<template>
  <div class="case-documents-manager">
    <div class="header">
      <el-button size="small" type="primary" icon="el-icon-refresh" @click="loadData">刷新</el-button>
      <el-button size="small" type="success" icon="el-icon-download" @click="handleBatchDownload" :loading="batchDownloadLoading">打包下载已盖章资料</el-button>
      <el-button size="small" type="default" @click="batchOperation" :disabled="!canOperate">发起盖章流程</el-button>
      <el-select size="small" v-model="filterForm.is_complete" placeholder="资料状态" clearable style="width: 120px; margin-left: 10px;">
        <el-option value="1" label="已完善"></el-option>
        <el-option value="0" label="未完善"></el-option>
      </el-select>
      <el-button size="small" type="default" @click="materialReady" :disabled="!canOperate" v-if="ERP.isPermission(8007003006)">线下资料已准备</el-button>
    </div>
    <div class="statistics-bar">
      <span>总房产数：{{ statistics.total }}</span>
      <span>已完善资料：{{ statistics.complete }}</span>
      <span>未完善资料：{{ statistics.incomplete }}</span>
    </div>
    <div class="table-wrapper">
      <el-table :data="displayHouseData" border v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="houseName" label="房产" width="200"></el-table-column>
        <el-table-column prop="caseStatusName" label="房产状态" width="100"></el-table-column>
        <el-table-column
          v-for="fileKey in fileKeys"
          :key="fileKey"
          :label="fileTypes[fileKey]"
        >
          <template slot-scope="scope">
            <div v-if="getFilesByHouseAndKey(scope.row.houseId, fileKey).length > 0">
              <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                <template v-for="(file, index) in getFilesByHouseAndKey(scope.row.houseId, fileKey)">
                  <el-tooltip :key="index" :content="file.file_name || ''" placement="top">
                    <el-link v-if="file.file_url"
                      :underline="true"
                      style="color: #409eff;"
                      size="small"
                      class="file-link"
                      @click="downloadFile(file)"
                    >
                      <span class="file-name">{{ file.file_name && file.file_name.length > 10 ? file.file_name.substring(0, 10) + '...' : file.file_name }}</span>
                    </el-link>
                    <el-tag v-if="file.is_check">线下已准备</el-tag>
                  </el-tooltip>
                </template>
              </div>
            </div>
            <div v-else style="color: #f56c6c;">待上传</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100, 500]"
        :page-size="pagination.per_page"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>

    <el-dialog width="1000px" :title="'补充资料 - ' + (currentEditHouse ? currentEditHouse.houseName : '')" :visible.sync="showUploadDialog"  @close="handleDialogClose">
      <el-table :data="fileTypesGroup" border style="width: 950px">
        <el-table-column prop="name" label="材料类型" width="100"></el-table-column>
        <el-table-column label="上传材料">
          <template slot-scope="scope">
            <el-table :data="Object.entries(scope.row.files)" border size="mini">
              <el-table-column prop="[1]" width="200">
                <template slot="header">
                  <span>材料名称</span>
                </template>
                <template slot-scope="props">
                  <span v-if="requiredFileKeys[caseType].indexOf(props.row[0]) !== -1" style="color: #f56c6c; margin-left: 2px;">*</span>
                  <span>{{ props.row[1] }}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="80">
                <template slot-scope="props">
                  <el-tag :type="getFileListByKey(props.row[0]).length > 0 ? 'success' : 'danger'" size="small">
                    {{ getFileListByKey(props.row[0]).length > 0 ? '已完善' : '未上传' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="已上传文件" width="350">
                <template slot-scope="props">
                  <div style="display: flex; flex-wrap: wrap; gap: 8px;min-width:180px;">
                    <div v-for="(file, index) in getFileListByKey(props.row[0])" :key="index" style="display: flex; align-items: center;">
                      <el-tag v-if="file.file_url"
                        size="small"
                        style="cursor: pointer;"
                        @click="downloadFile(file)"
                      >
                        {{ file.file_name }}
                        <i class="el-icon-download" style="margin-left: 5px;"></i>
                      </el-tag>
                      <i v-if="file.file_url"
                        class="el-icon-delete"
                        style="margin-left: 5px; cursor: pointer; color: #f56c6c;"
                        @click="deleteFile(file)"
                      ></i>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="线下已准备" width="120">
                <template slot-scope="props" v-if="!isRequired(props.row[0])">
                  <span v-if="getFileListByKey(props.row[0])[0] && getFileListByKey(props.row[0])[0].is_check">已确认</span>
                  <el-button v-else
                    size="small"
                    type="success"
                    :loading="checkFileKeys[props.row[0]]"
                    :disabled="checkFileKeys[props.row[0]]"
                    @click="handleCheckFile(props.row[0])"
                  >
                    线下已准备
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="上传" width="80">
                <template slot-scope="props">
                  <el-upload
                    :http-request="(param) => handleUploadFile(param, props.row[0])"
                    action=""
                    :show-file-list="false"
                    multiple
                  >
                    <el-button size="small" type="primary" :loading="uploadFileKeys[props.row[0]]" :disabled="uploadFileKeys[props.row[0]]">上传</el-button>
                  </el-upload>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import ButlerHttp from '../common/ButlerHttp';
import caseJs from './law_case/case';

export default {
  name: 'CaseDocumentsManager',
  inject: ['where', 'reginWhere'],
  props: {
    caseType: {
      type: String,
      default: 'case'
    },
    project_type: {
      type: Number,
      default: ''
    },
  },
  data() {
    return {
      loading: false,
      batchDownloadLoading: false,
      operationLoading: false,
      houseData: [],
      fileList: [],
      showUploadDialog: false,
      uploadFileKeys: {},
      checkFileKeys: {},
      currentEditHouse: null,
      selectedHouses: [],
      pagination: {
        page: 1,
        per_page: 10,
        total: 0
      },
      fileKeys: [],
      requiredFileKeys: {
        case: [ 'complaint_letter','evidence_list', 'owner_identity', 'reminder_letter'],
        third: ['complaint_letter' , 'delegation_doc' , 'evidence_list', 'owner_identity', 'reminder_letter']
      },
      filterForm: {
        is_complete: ''
      },
      statistics: {
        total: 0,
        complete: 0,
        incomplete: 0
      }
    };
  },
  computed: {
    fileTypes() {
      if (this.caseType === 'case') {
        return {
          complaint_letter: '起诉状',
          evidence_list: '证据清单（电子章）',
          owner_identity: '业主身份信息',
          service_contract: '物业服务合同 / 前期物业服务合同',
          reminder_letter: '催件函',
          other_letter : '其他资料（电子章）',
          business_license: '营业执照副本复印件（现章）',
          legal_representative_id: '法定代表人身份证明书（现章）',
          legal_representative_card: '法定代表人身份证复印件（现章）',
          authorization_letter: '授权委托书（现章）',
          employee_id: '员工身份证复印件',
          labor_contract: '劳动合同',
          social_insurance: '社保证明'
        };
      } else {
        return {
          complaint_letter: '起诉状',
          delegation_doc: '委托证明材料',
          evidence_list: '欠费清单',
          owner_identity: '业主身份信息',
          service_contract: '物业服务合同 / 前期物业服务合同',
          reminder_letter: '催件函',
          business_license: '营业执照副本复印件（现章）',
          legal_representative_id: '法定代表人身份证明书（现章）',
          legal_representative_card: '法定代表人身份证复印件（现章）',
          authorization_letter: '授权委托书（现章）'
        };
      }
    },
    displayHouseData() {
      let data = this.houseData.map(house => {
        const files = this.fileList.filter(f => String(f.house_id) === String(house.houseId));
        const isComplete = this.checkHouseComplete(house.houseId);
        const caseStatus = this.getHouseCaseStatus(house.houseId);
        return {
          ...house,
          isComplete,
          caseStatus,
          caseStatusName: '当前诉讼房产'
        };
      });

      if (this.filterForm.is_complete !== '') {
        const isComplete = this.filterForm.is_complete === '1';
        data = data.filter(house => house.isComplete === isComplete);
      }

      return data;
    },
    houseIds() {
      return this.houseData.map(house => house.houseId);
    },
    houseFileMap() {
      const map = {};
      this.fileList.forEach(file => {
        const houseId = String(file.house_id);
        if (!map[houseId]) {
          map[houseId] = [];
        }
        map[houseId].push(file);
      });
      return map;
    },
    allFileKeys() {
      return Object.keys(this.fileTypes);
    },
    canOperate() {
      return this.selectedHouses && this.selectedHouses.length > 0;
    },
    fileTypesGroup() {
      const groups = [];
      if (this.caseType === 'case') {
        groups.push({
          type: 1,
          name: '起诉材料',
          files: {
            complaint_letter: '起诉状',
            evidence_list: '证据清单（电子章）',
            owner_identity: '业主身份信息',
            // service_contract: '物业服务合同 / 前期物业服务合同',
            reminder_letter: '催件函',
            // other_letter : '其他资料（电子章）'
          }
        });
      } else {
        groups.push({
          type: 1,
          name: '起诉材料',
          files: {
            complaint_letter: '起诉状',
            delegation_doc: '委托证明材料',
            // evidence_list: '欠费明细',
            owner_identity: '业主信息(身份证复印件正反面、联系电话、居住地址)',
            // service_contract: '物业服务合同 / 前期物业服务合同',
            // reminder_letter: '催件函',
            // other_letter: '其他资料（电子章）',
          }
        });
      }
      const group2 = {
        type: 2,
        name: '公司主体资格证明',
        files: {
          business_license: '营业执照副本复印件（现章）',
          legal_representative_id: '法定代表人身份证明书（现章）',
          legal_representative_card: '法定代表人身份证复印件（现章）',
          authorization_letter: '授权委托书（现章）'
        }
      };
      if (this.caseType !== 'case') {
        // groups.push(group2);
      }
      // groups.push(group2);
      if (this.caseType === 'case') {
        // groups.push({
        //   type: 3,
        //   name: '员工代理所需材料',
        //   files: {
        //     employee_id: '员工身份证复印件',
        //     labor_contract: '劳动合同',
        //     social_insurance: '社保证明'
        //   }
        // });
      }
      return groups;
    },
    fileKeyToTypeMap() {
      let map = {};
      this.fileTypesGroup.forEach(type => {
        Object.keys(type.files).forEach(key => {
          map[key] = type.type;
        });
      });
      return map;
    }
  },
  watch: {
    "reginWhere": {
      handler: function(n, o) {
        this.pagination.page = 1;
        this.loadData();
      },
      deep: true
    },
    "where": {
      handler: function(n, o) {
        this.pagination.page = 1;
        this.loadData();
      },
      deep: true
    },
    caseType: {
      handler: function(n, o) {
        this.setFileKeys();
        this.pagination.page = 1;
        this.loadData();
      },
      immediate: true
    },
    fileTypes: {
      handler: function(n, o) {
        this.setFileKeys();
      },
      deep: true
    }
  },
  methods: {
    setFileKeys() {
      if (this.caseType === 'case') {
        this.fileKeys = [
          'complaint_letter',
          'evidence_list',
          'owner_identity',
          // 'service_contract',
          'reminder_letter',
          // 'business_license',
          // 'legal_representative_id',
          // 'legal_representative_card',
          // 'authorization_letter',
          // 'employee_id',
          // 'labor_contract',
          // 'social_insurance'
        ];
      } else {
        this.fileKeys = [
          'complaint_letter',
          'delegation_doc',
          'owner_identity',
          // 'service_contract',
          // 'reminder_letter',
          // 'business_license',
          // 'legal_representative_id',
          // 'legal_representative_card',
          // 'authorization_letter'
        ];
      }
    },
    loadData() {
      if (this.caseType === 'case') {
        this.loadCaseData();
      } else {
        this.loadThirdPartyData();
      }
    },
    loadCaseData() {
      this.loading = true;
      const params = {
        ...this.where,
        urge_type: 2,
        project_ids: typeof this.reginWhere.project_ids === 'string' ? this.reginWhere.project_ids : '',
        project_id: this.reginWhere.project_name,
        area_id: this.reginWhere.area_id,
        page: this.pagination.page,
        pageSize: this.pagination.per_page
      };

      ButlerHttp.post('LegalHouse/getLegalHouseList', params, res => {
        this.loading = false;
        if (res.code) {
          this.houseData = (res.data.list || []).map(item => ({
            houseId: item.HouseID || item.house_id || item.houseId || item.id,
            houseName: item['房产信息'] || item.houseName || item.HouseName || '未知房产',
            caseId: item.HouseID || item.id,
            caseItem: item
          }));
          this.pagination.total = res.data.total || 0;
          this.loadFileList();
          this.loadStatistics();
        }
      });
    },
    loadThirdPartyData() {
      this.loading = true;
      const where = {
        ...this.where,
        urge_type: 4
      };
      const params = {
        project_ids: typeof this.reginWhere.project_ids === 'string' ? this.reginWhere.project_ids : '',
        project_id: this.reginWhere.project_name,
        area_id: this.reginWhere.area_id,
        urge_type: 4
      };

      ButlerHttp.post("HouseCustomer/index?page=" + this.pagination.page + "&per_page=" + this.pagination.per_page, params, ret => {
        this.loading = false;
        if (ret.code) {
          this.pagination.total = ret.data.total || 0;
          this.houseData = (ret.data.data || []).map(item => ({
            houseId: item.house_id || item.HouseID || item.houseId || item.id,
            houseName: item.house_name || item['房产信息'] || (item.agreement && item.agreement.HouseName) || '未知房产',
            caseItem: item
          }));
          this.loadFileList();
          this.loadStatistics();
        }
      });
    },
    loadFileList() {
      if (!this.houseIds || this.houseIds.length === 0) {
        this.fileList = [];
        return;
      }

      this.loading = true;
      const houseIdsStr = this.houseIds.join(',');

      ButlerHttp.get('LawCaseFiles/getFileListByHouseIds', {
        house_ids: houseIdsStr,
        case_type: this.caseType
      }, res => {
        if (res.code) {
          this.fileList = res.data || [];
        }
        this.loading = false;
      });
    },
    checkHouseComplete(houseId) {
      const files = this.fileList.filter(f => String(f.house_id) === String(houseId));
      if (files.length === 0) return false;

      const allKeys = this.allFileKeys;
      for (const key of allKeys) {
        const keyFiles = files.filter(f => f.file_key === key);
        const hasFile = keyFiles.some(f => f.file_url && f.file_url.trim() !== '');
        const hasCheck = keyFiles.some(f => f.is_check === 1);
        if (!hasFile && !hasCheck) {
          return false;
        }
      }
      return true;
    },
    getHouseCaseStatus(houseId) {
      const files = this.fileList.filter(f => String(f.house_id) === String(houseId));
      if (files.length === 0) return 'current';
      const statuses = files.map(f => f.case_status);
      if (statuses.includes('current')) return 'current';
      return 'history';
    },
    updateStatistics() {
      const total = this.houseData.length;
      let complete = 0;
      let incomplete = 0;

      this.houseData.forEach(house => {
        if (this.checkHouseComplete(house.houseId)) {
          complete++;
        } else {
          incomplete++;
        }
      });

      this.statistics = { total, complete, incomplete };
    },
    loadStatistics() {
      const projectId = this.reginWhere.project_name;
      if (!projectId) return;

      ButlerHttp.get('LawCaseFiles/getStatics', {
        case_type: this.caseType,
        project_id: projectId
      }, res => {
        if (res.code) {
          this.statistics = {
            total: res.data.total_count || 0,
            complete: res.data.complete_count || 0,
            incomplete: res.data.incomplete_count || 0
          };
        }
      });
    },
    getFilesByHouseAndKey(houseId, fileKey) {
      let data =  this.fileList.filter(file =>
        String(file.house_id) === String(houseId) && file.file_key === fileKey
      );
      return data;
    },
    getFileListByKey(file_key) {
      if (!this.fileList) {
        return [];
      }
      if (this.currentEditHouse) {
        return this.fileList.filter(f =>
          String(f.house_id) === String(this.currentEditHouse.houseId) && f.file_key === file_key
        );
      }
      return this.fileList.filter(f => f.file_key === file_key);
    },
    downloadFile(file) {
      if (file.file_url) {
        let openUrl = caseJs.getFileUrl(file.file_url);
        window.open(openUrl);
      }
    },
    deleteFile(file) {
      this.$confirm('确定要删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post('LawCaseFiles/deleteFile', { id: file.id }, res => {
          if (res.code) {
            this.$message.success('删除成功');
            this.loadFileList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        });
      }).catch(() => {
      });
    },
    isRequired(fileKey) {
      const keys = this.requiredFileKeys[this.caseType];
      return keys ? keys.indexOf(fileKey) !== -1 : false;
    },
    handleCheckFile(fileKey) {
      const fileList = this.getFileListByKey(fileKey);
      const file = fileList.length > 0 ? fileList[0] : null;
      const newIsCheck = file && file.is_check ? 0 : 1;
      this.checkFileKeys[fileKey] = true;
      ButlerHttp.post('LawCaseFiles/checkFile', {
        house_id: this.currentEditHouse ? this.currentEditHouse.houseId : '',
        file_key: fileKey,
        is_check: newIsCheck
      }, res => {
        this.checkFileKeys[fileKey] = false;
        if (res.code) {
          this.$message.success(newIsCheck ? '已确认' : '已取消确认');
          this.loadFileList();
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      });
    },
    handleUploadFile(params, file_key) {
      let file_name = params.file.name;
      let file_type = this.fileKeyToTypeMap[file_key] || 1;

      if (!this.uploadFileKeys[file_key]) {
        this.uploadFileKeys[file_key] = true;

        caseJs.uploadFile(params.file, (res) => {
          if (res && res.hasOwnProperty('path')) {
            let file_data = {
              file_name: file_name,
              file_key: file_key,
              file_url: res.path,
              file_type: file_type,
              house_id: this.currentEditHouse ? this.currentEditHouse.houseId : (this.houseIds[0] || '')
            };

            ButlerHttp.post('LawCaseFiles/saveFile', { file_list: [file_data], case_type: this.caseType }, saveRes => {
              this.uploadFileKeys[file_key] = false;
              if (saveRes.code) {
                this.loadFileList();
                this.$message.success('上传成功');
              } else {
                this.$message.error(saveRes.msg || '保存失败');
              }
            });
          } else {
            this.uploadFileKeys[file_key] = false;
            this.$message.error('上传失败');
          }
        });
      }
    },
    handleSizeChange(val) {
      this.pagination.per_page = val;
      this.pagination.page = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.loadData();
    },
    handleEdit(row) {
      this.currentEditHouse = row;
      this.showUploadDialog = true;
    },
    handleDialogClose() {
      this.currentEditHouse = null;
    },
    handleSelectionChange(val) {
      this.selectedHouses = val;
    },
    batchOperation() {
      if (!this.canOperate) {
        this.$message.warning('请选择要发起盖章流程的房产');
        return;
      }
      this.submitFileOperation();
    },
    submitFileOperation() {
      this.operationLoading = true;

      const postData = {
        flow_list: this.selectedHouses.map(item => {
          return {
            house_id: item.houseId,
            flow_data: {},
            file_list: []
          };
        }),
        flow_type: 'file'
      };

      var that = this
      ButlerHttp.post('LawCaseFiles/saveFlow', postData, res => {
        this.operationLoading = false;
        if (res.code) {
          this.$message.success('操作成功');
          this.loadData();

          const batchNo = res.data.batch_no;
          const type = that.project_type == 1 ? '在管' : '撤场';
          const caseJs = {
            getTimestamp: () => {
              return Math.floor(new Date().getTime() / 1000);
            }
          };
          const urlParams = {
            sheet_id: '358',
            master_id: '295',
            timeValue: caseJs.getTimestamp(),
            unid: batchNo,
            type: type
          };
          const url = `/#/flow/FlowView?${new URLSearchParams(urlParams).toString()}`;
          window.open(url);
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      });
    },
    materialReady() {
      if (!this.canOperate) {
        this.$message.warning('请选择房产');
        return;
      }
      this.submitMaterialReady();
    },
    submitMaterialReady() {
      this.operationLoading = true;

      const postData = {
        flow_list: this.selectedHouses.map(item => {
          return {
            house_id: item.houseId,
            flow_data: {},
            file_list: []
          };
        }),
        fileTypes: this.fileTypes,
        flow_type: this.caseType
      };
      ButlerHttp.post('LawCaseFiles/submitMaterialReady', postData, res => {
        this.operationLoading = false;
        if (res.code === 1) {
          this.$message.success('操作成功');
          this.loadData();
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      });
    },
    handleBatchDownload() {
      const downloadHouses = this.selectedHouses.length > 0 ? this.selectedHouses : this.houseData;

      if (!downloadHouses || downloadHouses.length === 0) {
        this.$message.warning('暂无房产数据');
        return;
      }

      if (this.selectedHouses.length > 0) {
        this.$message.info('正在下载选中的 ' + this.selectedHouses.length + ' 个房产资料');
      }

      this.batchDownloadLoading = true;
      const houseIdsStr = downloadHouses.map(h => h.houseId).join(',');

      ButlerHttp.get('LawCaseFiles/getFileListByHouseIds', {
        house_ids: houseIdsStr,
        case_type: this.caseType
      }, res => {
        this.batchDownloadLoading = false;
        if (res.code) {
          const files = res.data || [];

          const stampedFiles = files.filter(f =>
            f.is_stamp == 1 && f.file_url && f.file_url.trim() !== ''
          );

          if (stampedFiles.length === 0) {
            this.$message.warning('暂无已盖章资料');
            return;
          }

          const zipData = this.formatZipData(stampedFiles, downloadHouses);

          ButlerHttp.post('LawCaseFiles/saveDownloadCache', { data: zipData }, cacheRes => {
            this.batchDownloadLoading = false;
            if (cacheRes.code) {
              const cacheKey = cacheRes.data.key;
              const routeUrl = this.$router.resolve({ path: '/law-case/zip', query: { key: cacheKey } });
              window.open(routeUrl.href, '_blank');
            } else {
              this.$message.error(cacheRes.msg || '保存缓存失败');
            }
          });
        } else {
          this.$message.error(res.msg || '获取文件列表失败');
        }
      });
    },
    formatZipData(files, downloadHouses) {
      const groupedFiles = {};

      files.forEach(file => {
        const houseId = String(file.house_id);
        if (!groupedFiles[houseId]) {
          groupedFiles[houseId] = [];
        }
        const filePath = file.file_url;
        const bucket = 'law';
        groupedFiles[houseId].push({
          url: filePath,
          bucket: bucket
        });
      });

      const result = [];
      Object.keys(groupedFiles).forEach(houseId => {
        const house = downloadHouses.find(h => String(h.houseId) === houseId);
        const houseName = house && house.houseName ? house.houseName : '房产' + houseId;
        result.push({
          folder: houseName,
          file_list: groupedFiles[houseId]
        });
      });

      return result;
    }
  },
  created() {
    this.setFileKeys();
    this.loadData();
  }
};
</script>

<style scoped lang="scss">
.header {
  margin-bottom: 10px;
}

.statistics-bar {
  margin-bottom: 10px;
  padding: 8px 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 10px;

  span {
    margin-right: 30px;
    font-size: 14px;
    color: #606266;
  }
}

.table-wrapper {
  overflow-x: auto;
}

.pagination-container {
  margin-top: 15px;
  text-align: right;
}

.file-link {
  display: inline-flex;
  align-items: center;
  max-width: 150px;

  .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/CaseDocumentsManager.vue